export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  imageUrl: string;
  imageUrlThumb: string;
  date: string;
  author: string;
  views: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: '1',
    title: '2026年最值得期待的十部国产大片，每一部都不容错过',
    slug: '2026-domestic-movies-preview',
    excerpt: '盘点2026年下半年即将上映的十部重量级国产电影，从科幻巨制到文艺佳作，总有一部适合你。',
    content: `<p>2026年的中国电影市场持续升温，多部备受瞩目的国产大片蓄势待发。从年初至今，国产电影票房已经突破500亿元大关，展现出强劲的市场活力。</p>
    <h2>科幻新纪元：《星际之门》</h2>
    <p>作为中国科幻电影的新标杆，《星际之门》讲述了一支中国宇航团队穿越神秘虫洞、探索未知宇宙的冒险故事。影片由国内顶尖特效团队操刀，视觉效果震撼人心，被誉为"中国科幻电影的又一里程碑"。</p>
    <h2>现实主义力作：《人间世》</h2>
    <p>改编自真实社会事件，《人间世》聚焦普通人在时代洪流中的命运起伏。导演以独特的镜头语言和细腻的情感刻画，让观众在银幕前感受到生活的温度与力量。</p>
    <h2>动画巅峰：《大闹天宫2》</h2>
    <p>时隔六十余年，经典IP《大闹天宫》迎来全新续作。融合传统水墨画风与现代3D技术，以全新的视觉语言重新演绎孙悟空的故事。</p>
    <p>此外，还有多部类型各异的作品值得关注，包括悬疑片《暗夜追踪》、喜剧片《欢乐家族3》、历史剧《长安十二时辰》电影版等。2026年下半年的电影市场，注定精彩纷呈。</p>`,
    category: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinema%20scene%20with%20dramatic%20lighting%20and%20film%20reel%20elements%2C%20warm%20golden%20tones%2C%20artistic%20composition%2C%20cinematic%20atmosphere%2C%20clean%20background%20with%20subtle%20film%20themed%20patterns%2C%20editorial%20style&width=800&height=400&seq=article-movies-01&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20minimal%20thumbnail%20with%20film%20elements%2C%20warm%20tones%2C%20compact%20composition&width=200&height=160&seq=article-movies-01-thumb&orientation=landscape',
    date: '2026-08-05',
    author: '影评人小王',
    views: 12580,
    tags: ['电影', '国产大片', '2026', '影评'],
  },
  {
    id: '2',
    title: '人工智能最新突破：大模型在多领域展现惊人能力',
    slug: 'ai-breakthrough-2026',
    excerpt: '2026年人工智能技术持续飞速发展，新一代大语言模型在医疗诊断、法律咨询、创意写作等领域展现出超越人类专家的惊人表现。',
    content: `<p>2026年是人工智能技术发展的又一个里程碑之年。随着算力的持续提升和算法的不断优化，新一代大语言模型在多个专业领域展现出了令人惊叹的能力。</p>
    <h2>医疗诊断：AI辅助诊断准确率达98%</h2>
    <p>最新研究表明，经过专业医疗数据训练的大语言模型，在常见疾病的辅助诊断中准确率已达到98%，超过了大多数全科医生的平均水平。特别是在影像诊断领域，AI系统能够识别出人眼难以察觉的微小病变。</p>
    <h2>法律咨询：AI律师助理上岗</h2>
    <p>多家顶级律师事务所已经开始部署AI法律助手系统，能够在数秒内完成合同审查、案例检索和法律条文分析等工作，将律师的工作效率提升了300%以上。</p>
    <h2>创意写作：AI小说获文学奖</h2>
    <p>今年5月，一篇由人机协作创作的小说获得了国内重要文学奖项的提名，引发了文学界关于"AI时代的创作边界"的广泛讨论。</p>
    <p>然而，专家也提醒，AI技术的快速发展带来了数据隐私、就业结构调整、算法偏见等一系列社会问题，需要政府、企业和社会各界共同应对。</p>`,
    category: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20neural%20network%20visualization%20with%20glowing%20nodes%20and%20connections%2C%20clean%20white%20background%2C%20minimal%20tech%20aesthetic%2C%20warm%20coral%20accent%20highlights%2C%20professional%20look&width=800&height=400&seq=article-ai-02&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=AI%20neural%20network%20minimal%20thumbnail%2C%20clean%20white%20background%2C%20coral%20accent&width=200&height=160&seq=article-ai-02-thumb&orientation=landscape',
    date: '2026-08-03',
    author: '科技观察员李明',
    views: 23450,
    tags: ['人工智能', 'AI', '大模型', '科技前沿'],
  },
  {
    id: '3',
    title: '健康生活新主张：科学饮食与适度运动的最佳搭配方案',
    slug: 'healthy-lifestyle-2026',
    excerpt: '权威医学研究揭示，科学搭配饮食与适度运动是保持健康的黄金法则。本文为您详细解读2026年最新健康生活指南。',
    content: `<p>在快节奏的现代生活中，保持健康已经成为越来越多人关注的焦点。2026年，世界卫生组织发布了最新版《全球健康生活指南》，为人们提供了科学、实用的健康建议。</p>
    <h2>科学饮食：地中海饮食模式受推崇</h2>
    <p>研究表明，以橄榄油、全谷物、新鲜蔬果、鱼类和坚果为主的地中海饮食模式，能够显著降低心血管疾病、糖尿病和某些癌症的发病风险。专家建议每周至少食用两次深海鱼类，每天摄入不少于500克的新鲜蔬菜水果。</p>
    <h2>适度运动：150分钟黄金法则</h2>
    <p>每周累计150分钟的中等强度有氧运动，配合2-3次力量训练，是最科学的运动方案。快走、游泳、骑行都是理想的选择。关键不在于运动强度有多大，而在于能否长期坚持。</p>
    <h2>心理健康：不容忽视的第四维度</h2>
    <p>除了身体健康，心理健康同样重要。每天10分钟的正念冥想、保持良好的社交关系、培养兴趣爱好，都是维护心理健康的有效方式。</p>
    <p>健康不是一蹴而就的目标，而是一个持续的生活方式。从今天开始，为自己制定一个切实可行的健康计划吧。</p>`,
    category: 'jiankang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20healthy%20lifestyle%20scene%20with%20colorful%20fruits%20and%20vegetables%2C%20yoga%20mat%2C%20clean%20bright%20background%2C%20natural%20lighting%2C%20minimal%20composition%2C%20warm%20and%20inviting%20atmosphere&width=800&height=400&seq=article-health-03&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Healthy%20food%20minimal%20thumbnail%2C%20fresh%20colorful%20vegetables%2C%20clean%20bright%20look&width=200&height=160&seq=article-health-03-thumb&orientation=landscape',
    date: '2026-08-01',
    author: '健康顾问张医生',
    views: 18920,
    tags: ['健康', '饮食', '运动', '生活指南'],
  },
  {
    id: '4',
    title: '全球经济新格局：新兴市场崛起与投资机遇分析',
    slug: 'global-economy-2026',
    excerpt: '2026年全球经济格局持续重塑，东南亚、中东等新兴市场展现出强劲增长动力，为投资者带来新的机遇与挑战。',
    content: `<p>2026年，全球经济在经历了一系列深刻变革后，正逐步形成新的格局。传统发达经济体增长放缓的同时，新兴市场国家展现出强劲的发展势头。</p>
    <h2>东南亚：数字经济的蓝色海洋</h2>
    <p>东南亚地区数字经济规模在2026年预计突破4000亿美元。印度尼西亚、越南、菲律宾等国凭借年轻的人口结构和高互联网渗透率，成为全球科技巨头争相布局的热土。</p>
    <h2>中东：从石油到多元化转型</h2>
    <p>以沙特阿拉伯"2030愿景"和阿联酋"2071百年计划"为代表，中东国家正加速经济多元化转型，在可再生能源、智慧城市、金融科技等领域投入巨资。</p>
    <h2>投资建议：分散化与长期主义</h2>
    <p>专家建议，在当前复杂多变的全球经济环境下，投资者应采取更加分散化的资产配置策略，关注具有长期增长潜力的新兴市场，同时保持足够的风险意识。</p>`,
    category: 'caijing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20global%20economy%20concept%20with%20world%20map%20and%20rising%20graph%20lines%2C%20clean%20white%20background%2C%20warm%20golden%20accents%2C%20professional%20financial%20visualization%2C%20minimal%20design&width=800&height=400&seq=article-economy-04&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Global%20economy%20graph%20minimal%20thumbnail%2C%20rising%20chart%2C%20golden%20accents&width=200&height=160&seq=article-economy-04-thumb&orientation=landscape',
    date: '2026-07-28',
    author: '财经分析师赵峰',
    views: 15670,
    tags: ['经济', '投资', '新兴市场', '财经分析'],
  },
  {
    id: '5',
    title: '2026高考志愿填报指南：热门专业趋势与就业前景深度解析',
    slug: 'gaokao-2026-guide',
    excerpt: '高考志愿填报在即，本文深度解析2026年各大热门专业的就业前景与发展趋势，助力考生做出最适合自己的选择。',
    content: `<p>高考成绩公布后，志愿填报成为考生和家长最为关注的话题。选对专业，不仅关系到大学四年的学习体验，更影响着未来的职业发展。本文为您详细解读2026年最具潜力的专业方向。</p>
    <h2>人工智能与数据科学：风口上的专业</h2>
    <p>随着AI技术的全面爆发，人工智能、数据科学、机器学习等相关专业持续升温。据统计，2026年AI相关岗位的平均薪资已突破40万元/年，且人才缺口仍在扩大。</p>
    <h2>新能源与碳中和：绿色未来的建设者</h2>
    <p>在国家"双碳"战略的推动下，新能源科学与工程、储能技术、碳管理等专业就业前景广阔。预计到2030年，新能源领域将创造超过1000万个就业岗位。</p>
    <h2>生物医药：疫情后的黄金赛道</h2>
    <p>全球公共卫生意识的提升推动了生物医药产业的快速发展。基因编辑、精准医疗、创新药物研发等领域对高素质人才的需求持续增长。</p>
    <h2>选择建议</h2>
    <p>选专业不能盲目追热点。建议考生结合自身兴趣、能力特长和社会需求，做出理性选择。适合的才是最好的。</p>`,
    category: 'jiaoyu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20education%20exam%20preparation%20scene%20with%20books%20and%20laptop%2C%20warm%20natural%20light%2C%20clean%20desk%20setup%2C%20minimal%20composition%2C%20inspirational%20atmosphere%2C%20soft%20cream%20background&width=800&height=400&seq=article-gaokao-05&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Education%20books%20minimal%20thumbnail%2C%20warm%20light%2C%20clean%20desk&width=200&height=160&seq=article-gaokao-05-thumb&orientation=landscape',
    date: '2026-07-25',
    author: '升学规划师陈老师',
    views: 45230,
    tags: ['高考', '志愿填报', '专业选择', '就业前景'],
  },
  {
    id: '6',
    title: '云南深度游攻略：避开人潮，探寻那些不为人知的秘境',
    slug: 'yunnan-hidden-gems',
    excerpt: '厌倦了丽江大理的人山人海？跟随我们的脚步，发现云南那些游客稀少却美到窒息的小众旅行地。',
    content: `<p>云南，这片被誉为"彩云之南"的神奇土地，不仅有丽江古城、大理洱海等经典景点，更隐藏着许多鲜为人知的绝美秘境。</p>
    <h2>沙溪古镇：被遗忘的茶马古道驿站</h2>
    <p>位于大理和丽江之间的沙溪古镇，是茶马古道上唯一幸存的古集市。青石板路、古戏台、老茶铺，这里的一切都保留着百年前的模样。每周五的古老集市，依然有周边村寨的少数民族前来交易。</p>
    <h2>丙中洛：人神共居的地方</h2>
    <p>位于怒江傈僳族自治州的丙中洛，被旅行者称为"人神共居的天堂"。清晨的云雾缭绕中，怒江第一湾的壮丽景色令人屏息。这里居住着藏族、怒族、傈僳族等多个民族，保留着最原始的生活方式。</p>
    <h2>翁丁佤寨：最后的原始部落</h2>
    <p>临沧市的翁丁佤寨，是中国保存最为完整的佤族原始村落。茅草屋顶、牛头图腾、古老的祭祀文化，让人仿佛穿越回了千年前的部落时代。</p>
    <h2>旅行贴士</h2>
    <p>这些小众目的地的交通相对不便，建议租车自驾或参加当地的小团游。最佳旅行时间为每年的3-5月和9-11月，此时气候宜人，景色最美。</p>`,
    category: 'lvyou',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Yunnan%20ancient%20town%20with%20traditional%20Chinese%20architecture%2C%20misty%20mountains%20background%2C%20stone%20path%2C%20warm%20sunlight%2C%20serene%20atmosphere%2C%20minimal%20composition%2C%20travel%20photography%20style&width=800&height=400&seq=article-yunnan-06&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Yunnan%20ancient%20town%20minimal%20thumbnail%2C%20misty%20mountains%2C%20warm%20light&width=200&height=160&seq=article-yunnan-06-thumb&orientation=landscape',
    date: '2026-07-20',
    author: '旅行达人小林',
    views: 28760,
    tags: ['云南', '旅游攻略', '小众景点', '深度游'],
  },
  {
    id: '7',
    title: '重大政策解读：新一轮减税降费措施惠及千万中小微企业',
    slug: 'tax-reduction-policy-2026',
    excerpt: '国务院发布新一轮减税降费政策，预计全年将为中小微企业减负超过8000亿元，有力提振市场主体信心。',
    content: `<p>国务院日前发布《关于进一步减轻企业负担促进实体经济高质量发展的若干措施》，推出新一轮大规模减税降费政策。这是继2025年之后，国家再次以"真金白银"支持企业发展。</p>
    <h2>增值税优惠再加码</h2>
    <p>对月销售额10万元以下的增值税小规模纳税人，继续免征增值税。适用3%征收率的增值税小规模纳税人，减按1%征收率征收。预计全年减税规模超过5000亿元。</p>
    <h2>企业所得税减免扩围</h2>
    <p>小型微利企业年应纳税所得额不超过300万元的部分，减按25%计入应纳税所得额，按20%的税率缴纳企业所得税。高新技术企业享受15%优惠税率。</p>
    <h2>社保缴费负担持续降低</h2>
    <p>延续实施阶段性降低失业保险、工伤保险费率政策，工伤保险基金累计结余可支付月数在18至23个月的统筹地区，可以现行费率为基础下调20%。</p>
    <p>专家表示，此轮减税降费政策的实施，将进一步优化营商环境，激发市场活力，为中国经济高质量发展注入强劲动力。</p>`,
    category: 'zixun',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20government%20policy%20document%20concept%20with%20official%20seal%20and%20modern%20office%20elements%2C%20clean%20professional%20look%2C%20warm%20neutral%20background%2C%20minimal%20composition&width=800&height=400&seq=article-tax-07&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Policy%20document%20minimal%20thumbnail%2C%20official%20seal%2C%20clean%20background&width=200&height=160&seq=article-tax-07-thumb&orientation=landscape',
    date: '2026-07-18',
    author: '政策解读员王磊',
    views: 32410,
    tags: ['减税降费', '政策解读', '中小企业', '经济发展'],
  },
  {
    id: '8',
    title: '家居收纳秘籍：50平米小户型也能拥有超大储物空间',
    slug: 'home-storage-tips',
    excerpt: '小户型收纳不再烦恼！资深室内设计师分享实用收纳技巧，让你的家既整洁又美观，空间感瞬间翻倍。',
    content: `<p>对于居住在小户型的朋友来说，"收纳"永远是一个绕不开的话题。如何在有限的空间里实现高效收纳，让家既整洁又舒适？本文为您带来最实用的收纳解决方案。</p>
    <h2>垂直空间：被忽视的收纳宝地</h2>
    <p>大部分家庭的收纳只利用了地面以上1.5米的空间，而墙面高处和天花板下方区域往往被浪费。安装顶天立地的定制柜体，或者利用墙面置物架，可以让收纳空间增加50%以上。</p>
    <h2>多功能家具：一物多用的智慧</h2>
    <p>选择带储物功能的床、可折叠的餐桌、带收纳格的沙发等多功能家具，是小户型收纳的法宝。一张储物床可以收纳相当于一个大衣柜的物品量。</p>
    <h2>收纳分区：让每件物品都有自己的"家"</h2>
    <p>按照使用频率对物品进行分区收纳：常用物品放在触手可及的位置，换季物品放在高处或床底，纪念品和很少使用的物品可以放在最不易取到的地方。</p>
    <h2>断舍离：收纳的第一步</h2>
    <p>最好的收纳方法，其实是减少不必要的物品。定期进行"断舍离"，只保留真正需要和喜爱的物品，你会发现收纳变得轻松许多。</p>`,
    category: 'shenghuo',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20interior%20with%20organized%20storage%20solutions%2C%20clean%20bright%20space%2C%20warm%20natural%20lighting%2C%20Scandinavian%20style%2C%20cozy%20atmosphere%2C%20professional%20interior%20photography&width=800&height=400&seq=article-storage-08&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Organized%20home%20interior%20minimal%20thumbnail%2C%20clean%20bright%20storage&width=200&height=160&seq=article-storage-08-thumb&orientation=landscape',
    date: '2026-07-15',
    author: '室内设计师陈晨',
    views: 21340,
    tags: ['收纳', '小户型', '家居', '装修'],
  },
  {
    id: '9',
    title: '2026年夏季最IN穿搭趋势：复古风潮强势回归',
    slug: 'summer-fashion-2026',
    excerpt: '从T台到街头，复古元素全面占领2026夏季时尚圈。带你了解今年夏天最不能错过的五大穿搭趋势。',
    content: `<p>2026年夏季，时尚圈掀起了一股强劲的复古风潮。从90年代的极简主义到千禧年的Y2K风格，经典元素经过重新演绎，焕发出全新的生命力。</p>
    <h2>90年代极简主义回归</h2>
    <p>Clean Fit风格在这个夏天持续走红。纯色T恤、直筒牛仔裤、简约西装外套，强调剪裁和质感，用最基础的单品打造最高级的搭配感。</p>
    <h2>Y2K千禧风潮</h2>
    <p>低腰裤、露脐装、闪亮配饰...Y2K风格在这个夏天达到了新的高峰。与去年不同的是，今年的Y2K更注重实用性和日常可穿性。</p>
    <h2>新中式：东方美学的时尚表达</h2>
    <p>将传统中式元素融入现代服装设计，"新中式"风格成为2026年最亮眼的时尚趋势之一。盘扣、立领、旗袍元素、水墨印花，展现出独特的东方韵味。</p>
    <h2>色彩趋势：多巴胺色彩大行其道</h2>
    <p>亮橙色、荧光绿、电光紫...大胆明亮的色彩成为2026夏季的主旋律。时尚心理学家表示，这种"多巴胺穿搭"反映了人们对积极情绪的渴望。</p>`,
    category: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20fashion%20layout%20with%20colorful%20clothing%20items%2C%20clean%20white%20background%2C%20minimal%20editorial%20style%2C%20warm%20accent%20colors%2C%20professional%20fashion%20photography&width=800&height=400&seq=article-fashion-09&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Fashion%20layout%20minimal%20thumbnail%2C%20colorful%20clothing%2C%20clean%20white&width=200&height=160&seq=article-fashion-09-thumb&orientation=landscape',
    date: '2026-07-12',
    author: '时尚编辑美美',
    views: 19450,
    tags: ['时尚', '穿搭', '复古', '2026夏季'],
  },
  {
    id: '10',
    title: '手机摄影进阶技巧：用普通手机拍出专业级大片',
    slug: 'mobile-photography-tips',
    excerpt: '无需昂贵设备！掌握这些手机摄影技巧，让你随时随地捕捉生活中的精彩瞬间，拍出令人惊艳的作品。',
    content: `<p>随着手机摄像头技术的飞速发展，用手机拍出专业级照片已经成为可能。本文将分享手机摄影的核心技巧，帮助你的朋友圈照片质量提升一个档次。</p>
    <h2>构图法则：三分法与引导线</h2>
    <p>打开手机相机的网格线功能，将主体放在三分线的交点处，这是最基础也最有效的构图方法。同时，利用道路、栏杆、河流等自然线条作为"引导线"，将观众的目光引向画面主体。</p>
    <h2>光线的艺术：黄金时刻的魅力</h2>
    <p>日出后和日落前的一小时被称为"黄金时刻"，此时的阳光柔和温暖，能够给照片带来最美的光影效果。尽量避免在正午强光下拍摄，如果必须拍摄，可以利用阴影来创造层次感。</p>
    <h2>后期处理：适度为王</h2>
    <p>手机自带的编辑功能已经足够强大。调整曝光、对比度、饱和度和锐度，可以显著提升照片质量。但要记住，后期处理的原则是"增色不增假"，过度的滤镜反而会破坏照片的自然美感。</p>
    <h2>创意拍摄：尝试不同视角</h2>
    <p>不要总是站在同一高度拍摄。尝试俯拍、仰拍、低角度拍摄，甚至将手机贴近地面或水面，独特的视角往往能带来意想不到的惊喜效果。</p>`,
    category: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20concept%20with%20mobile%20phone%20capturing%20beautiful%20scene%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20creative%20composition%2C%20professional%20look&width=800&height=400&seq=article-photo-10&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20minimal%20thumbnail%2C%20mobile%20phone%20camera%2C%20warm%20light&width=200&height=160&seq=article-photo-10-thumb&orientation=landscape',
    date: '2026-07-10',
    author: '摄影师老刘',
    views: 17680,
    tags: ['手机摄影', '摄影技巧', '拍照', '教程'],
  },
  {
    id: '101',
    title: '新能源汽车2026年度横评：十大品牌实力对决',
    slug: 'new-energy-cars-2026',
    excerpt: '2026年新能源汽车市场竞争白热化，本文从续航、智能驾驶、性价比等维度，全面对比十款热门新能源车型。',
    content: `<p>2026年，中国新能源汽车市场渗透率已超过60%，市场竞争进入白热化阶段。本文为您带来年度十大热门新能源车型的全面对比评测。</p>
    <h2>续航能力排行榜</h2>
    <p>在CLTC工况下，多款车型续航已突破1000公里大关。其中，搭载新一代固态电池的旗舰车型表现尤为亮眼，实际道路续航达成率超过90%。</p>
    <h2>智能驾驶体验对比</h2>
    <p>城市NOA（领航辅助驾驶）功能已在15万以上车型中基本普及。不同品牌在复杂路况的处理能力上仍存在明显差异，头部品牌在通过率和安全性方面领先明显。</p>
    <h2>性价比之王花落谁家</h2>
    <p>在15-20万元价格区间，多款车型提供了超越期待的价值。8155芯片、L2+级辅助驾驶、600km+续航已经成为这个价位的标配。</p>`,
    category: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20in%20clean%20studio%20setting%2C%20minimal%20white%20background%2C%20futuristic%20design%2C%20professional%20automotive%20photography%2C%20warm%20lighting%20highlights&width=800&height=400&seq=article-evcars-11&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20minimal%20thumbnail%2C%20clean%20studio%2C%20modern%20design&width=200&height=160&seq=article-evcars-11-thumb&orientation=landscape',
    date: '2026-07-08',
    author: '汽车评测师阿强',
    views: 28930,
    tags: ['新能源汽车', '电动车', '评测', '买车指南'],
  },
  {
    id: '102',
    title: '一线城市房价走势分析：2026下半年购房时机到了吗',
    slug: 'housing-market-2026',
    excerpt: '2026年楼市政策持续松绑，一线城市房价出现企稳回升迹象。刚需购房者应该如何把握时机？',
    content: `<p>经历了连续两年的调整后，2026年中国房地产市场出现了积极变化。一线城市成交量逐步回升，部分热点区域房价开始小幅上涨。</p>
    <h2>政策面：利好持续释放</h2>
    <p>从降低首付比例到下调房贷利率，从取消限购到购房补贴，各城市纷纷出台楼市松绑政策。央行最新数据显示，个人住房贷款加权平均利率已降至历史低位。</p>
    <h2>市场面：量升价稳成主基调</h2>
    <p>2026年上半年，一线城市二手房成交量同比增长约25%，新房去化周期明显缩短。但房价并未出现大幅反弹，"以价换量"仍是市场主流。</p>
    <h2>购房建议</h2>
    <p>对于刚需购房者来说，当前市场环境较为友好——利率低、选择多、议价空间大。但投资性购房仍需谨慎，房地产"只涨不跌"的时代已经一去不复返。</p>`,
    category: 'caijing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20with%20residential%20buildings%2C%20clean%20minimal%20architectural%20photography%2C%20warm%20sunset%20lighting%2C%20professional%20real%20estate%20aesthetic%2C%20soft%20atmospheric%20tones&width=800&height=400&seq=article-housing-12&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=City%20skyline%20minimal%20thumbnail%2C%20residential%20buildings%2C%20warm%20sunset&width=200&height=160&seq=article-housing-12-thumb&orientation=landscape',
    date: '2026-07-05',
    author: '房产分析师孙明',
    views: 35670,
    tags: ['房价', '楼市', '购房', '一线城市'],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.category === categoryId);
}

export function getRecentArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
}

export function getPopularArticles(count: number = 5): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
}

export function getRelatedArticles(article: Article, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
}